<template>
  <div class="flex flex-col md:flex-row md:justify-between">
    <div class="w-64 flex-shrink-0">
      <span class="text-grayDark font-medium">Topics I like discussing...</span>
    </div>
    <div class="md:ml-8 mt-1 md:mt-0 flex-1 flex items-center justify-between">
      <div v-if="! edit" class="w-full flex items-center justify-between">
        <div>
          <ul class="list-disc flex flex-col space-y-3 pl-4" v-if="guest.topics.length">
            <li v-for="(topic, index) in guest.topics" :key="`topic-list-${index}`" class="text-blue-800 font-medium">
              {{ topic }}
            </li>
          </ul>
          <div v-else class="flex items-center text-sm text-gray-500">
            No topics added.
          </div>
        </div>
        <Edit @edit="edit = true"/>
      </div>
      <div v-else class="w-full">
        <ValidationObserver ref="topicsForm" v-slot="{ handleSubmit }">
          <form @submit.prevent="handleSubmit(update)" method="post">
            <div v-if="! form.topics.length" class="h-12 text-sm text-gray-500">
              No topics added.
            </div>
            <div>
                <div class="flex mb-4" v-for="(item, index) in form.topics" :key="`list-item-${index}`">
                  <div class="w-full mr-3">
                    <ValidationProvider mode="eager" rules="required" :name="`Topic`" :vid="`topic.${index}`" v-slot="{ errors }">
                      <div>
                        <input type="text" class="guestio-form-input" :class="{'error-class': errors.length}" placeholder="Type or paste topic" v-model="form.topics[index]">
                      </div>
                    </ValidationProvider>
                  </div>
                  <div class="w-1/12 my-auto">
                    <button class="rounded-full bg-gray-50 flex justify items-center p-2 hover:bg-softGray" @click.prevent="removeItem(index)">
                      <CrossIcon :classes="'w-6'"/>
                    </button>
                  </div>
                </div>
                <button type="button" class="text-pink-500  underline" @click.prevent="addItem">Add topic +</button>
            </div>
            <div class="mt-4 flex items-center justify-end">
              <SaveOrCancel @cancel="edit = false" :working="working"/>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState} from "vuex";
  import CrossIcon from "@/components/svgs/CrossIcon"
  import SaveOrCancel from "@/components/shared/SaveOrCancel";
  import Edit from "@/components/shared/Edit";

  export default {
    components: {CrossIcon, SaveOrCancel, Edit},

    data() {
      return {
        working: false,
        edit: false,
        form: {
          topics: null,
        }
      }
    },

    watch: {
      edit(edit) {
        if (edit) return

        this.form.topics = this.guest.topics
      }
    },

    mounted() {
      this.form.topics = this.user.guest.topics
      this.form.id = this.user.guest.id
    },

    methods: {
      update() {
        this.working = true

        this.$store.dispatch('guest/updateGuest', this.form)
          .then(() => {
            this.working = false
            this.edit = false
          })
          .catch(error => {
            this.working = false
            if (error.response) {
              this.$refs.topicsForm.setErrors(error.response.data.errors)
            }
          })
      },

      addItem() {
        this.form.topics.push('')
      },

      removeItem(index) {
        this.form.topics.splice(index, 1)
      }
    },

    computed: {
      ...mapState({
        guest: state => state.guest.guest,
        user: state => state.auth.user
      }),
    },
  }
</script>

<style scoped>
  input.error-class {
    @apply border;
    border-color: #FF2F3B !important;
    background-color: #fff5f5 !important;
  }
</style>
